import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {
  userApplications:Array<any> = null;
  selectedApplication: any = null;
}
